import { render, staticRenderFns } from "./FeatureRequest.vue?vue&type=template&id=0203829c&scoped=true"
import script from "./FeatureRequest.vue?vue&type=script&lang=js"
export * from "./FeatureRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0203829c",
  null
  
)

export default component.exports